<button [iconButton]
        [status]="status"
        class="_wishlist"
        [icon]="inWishlist ? 'wishlist-fill' : 'wishlist'"
        (click)="toggle()"
        [attr.aria-label]="inWishlist ? 'Remove from wishlist' : 'Add to wishlist'"
        cy-wishlistaddbutton></button>